import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styles from './stickyIconSet.scss';
import * as Icons from './icons'
import { getRouter, getEnv } from '../../utils/helper';
import { fetchChatbotState } from '../../redux/reducers';
import { useDispatch } from "react-redux";
import { getLocalStorage } from "../../utils/helper";


export default function StickyIconSet(props) {
  const {
    chatBotURL,
    openChatBotInFrame,
    chatBotFrameWidth,
    chatBotFrameHeight,
    chatBotFrameTop,
    chatBotFrameLeft,
    excludeInURL,
    bubbleCloseInSeconds
  } = props;
  const [backToTopVisible, setBackToTopVisible] = useState(false);
  const [hideStickyIcon, setHideStickyIcon] = useState(false);
  const [showChat, setShowChat] = useState(true);
  const [backToTopIcon, setBackToTopIcon] = useState();
  const [icon, setIcon] = useState();
  const [textIcon, setTextIcon] = useState();
  // const [text, setText] = useState();
  const [enabled, setEnabled] = useState(true);
  const [url, setURL] = useState();
  const dispatch = useDispatch();

  const route = getRouter();

  let chatbotData = getLocalStorage("chatbot"); //Get chatbot data from local storage

  useEffect(() => {
    if (route?.asPath && excludeInURL.includes(route.asPath.split('?')[0].toLowerCase())) {
      setHideStickyIcon(true)
    } else {
      setHideStickyIcon(false)
    }
    const timeId = setTimeout(() => {
      // After N seconds set the show value to false
      setShowChat(false)
    }, bubbleCloseInSeconds * 1000)
  }, [route])

  useEffect(() => {
    if (chatbotData == undefined || chatbotData === "undefined" || Object.keys(chatbotData).length == 0) {
      dispatch(fetchChatbotState())
    }
    else {
      if (!chatbotData._version && Array.isArray(JSON.parse(chatbotData)) && JSON.parse(chatbotData).length > 0)
        chatbotData = JSON.parse(chatbotData)[0];

      setBackToTopIcon(chatbotData?.back_to_top_icon?.url ?? Icons?.BackToTop?.default);
      setIcon(chatbotData?.pure_icon?.url ?? Icons?.Chatbot?.default);
      setTextIcon(chatbotData?.text_icon?.url ?? Icons?.ChatbotExpanded?.default);
      setEnabled(chatbotData?.enabled);

      if (getEnv() === 'prod' || getEnv() === 'pd')
        setURL(chatbotData.prod_link?.href);
      else
        setURL(chatbotData.qa_link?.href);
    }
  }, [Object.keys(chatbotData).length]);

  const toggleBackToTop = () => {
    const scrolled = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop || 0;
    if (scrolled == 0) {
      setBackToTopVisible(false)
    }
    else {
      setBackToTopVisible(true);
    }

    // if (scrolled > 300){
    //   setBackToTopVisible(true)
    // } 
    // else if (scrolled <= 300){
    //   setBackToTopVisible(false)
    // }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
      /* you can also use 'auto' behaviour
         in place of 'smooth' */
    });
  };

  if (typeof window !== "undefined") {
    window.addEventListener('scroll', toggleBackToTop);
  }

  const openChatbot = () => {
    if (typeof window !== "undefined") {
      if (openChatBotInFrame) {
        window.open(url ?? chatBotURL, '', `width=${chatBotFrameWidth},height=${chatBotFrameHeight},top=${chatBotFrameTop},left=${chatBotFrameLeft}`);
      }
      else {
        window.open(url ?? chatBotURL);
      }
    }
  }

  return (
    <div>
      {!hideStickyIcon && backToTopVisible && enabled && <div className={styles.backToTop} onClick={scrollToTop}><img src={backToTopIcon}></img></div>}
      {
        !hideStickyIcon && showChat && enabled &&
        // <div className={styles.chatDialog}>
        //   Hi！我是小安，有任何問題都可以問我唷！ 
        //   <div className={styles.dialogPointer}></div>
        // </div>
        <div className={styles.chatbot} onClick={openChatbot}><img src={textIcon}></img></div>
      }
      {
        !hideStickyIcon && !showChat && enabled && <div className={styles.chatbot} onClick={openChatbot}><img src={icon}></img></div>
      }

    </div>
  );
}

StickyIconSet.defaultProps = {
  chatBotURL: "",
  openChatBotInFrame: false,
  chatBotFrameWidth: 400,
  chatBotFrameHeight: 600,
  chatBotFrameTop: 0,
  chatBotFrameLeft: 0,
  excludeInURL: [],
  bubbleCloseInSeconds: 2
};
StickyIconSet.propTypes = {
  chatBotURL: PropTypes.string,
  openChatBotInFrame: PropTypes.bool,
  chatBotFrameWidth: PropTypes.number,
  chatBotFrameHeight: PropTypes.number,
  chatBotFrameTop: PropTypes.number,
  chatBotFrameLeft: PropTypes.number,
  excludeInURL: PropTypes.array,
  bubbleCloseInSeconds: PropTypes.number
};
